// extracted by mini-css-extract-plugin
export default {"container":"SeriesSelectValue-module__container--IuwMF","icon":"SeriesSelectValue-module__icon--SxIiJ"};